{
  "title": "Invisibility To Cameras (UA)",
  "source": "Unearthed Arcana 7 - Modern Magic",
  "levelAndSchool": "3rd-level illusion (technomagic)",
  "level": 3,
  "castingTime": "1 action",
  "range": "10 feet",
  "components": "V, S, M (a scrap of black paper)",
  "duration": "Concentration, up to 1 minute",
  "description": [
    "Four creatures of your choice within range become undetectable to electronic sensors and cameras for the duration of the spell. Anything a target is wearing or carrying is likewise undetectable as long as it is on the target’s person. The targets remain visible to vision."
  ],
  "spellLists": ["arcane-trickster", "sorcerer", "warlock", "wizard"]
}
